import { parseContractMoney } from '../components/actions/Tracking/TrackingHelpers';

type PropertyDepositSource = {
  deposit?: string | number | null;
  price?: number | string | null;
};

/** Tiền cọc từ product card: deposit × giá thuê/tháng; không có thì mặc định 1 tháng */
export function resolvePropertyDepositVnd(
  property?: PropertyDepositSource | null,
  monthlyRentFallback?: number | string | null,
): number {
  const monthlyRent =
    parseContractMoney(property?.price) || parseContractMoney(monthlyRentFallback);

  const depositRaw = property?.deposit;
  if (depositRaw == null || String(depositRaw).trim() === '') {
    return monthlyRent > 0 ? monthlyRent : 0;
  }

  const parsedDeposit = parseContractMoney(depositRaw);
  if (parsedDeposit <= 0) {
    return monthlyRent > 0 ? monthlyRent : 0;
  }

  const monthCount = Math.round(parsedDeposit);
  const isIntegerLike = Math.abs(parsedDeposit - monthCount) < 1e-6;

  if (monthlyRent > 0 && isIntegerLike && monthCount >= 1 && monthCount <= 12 && parsedDeposit < 1000) {
    return monthlyRent * monthCount;
  }

  if (parsedDeposit >= 100000) {
    return parsedDeposit;
  }

  if (monthlyRent > 0 && isIntegerLike && monthCount >= 1 && monthCount <= 12) {
    return monthlyRent * monthCount;
  }

  return parsedDeposit;
}

export function formatContractMoneyVnd(amount: number): string {
  if (!amount || amount <= 0) return '';
  return `${amount.toLocaleString('vi-VN')}`;
}
